<template>
  <div class="content">
    <div class="table-responsive">
      <table class="table table-hover table-clean table-vcenter" style="width:100%;">
        <thead>
          <tr>
            <th>ID št. obrata</th>
            <th>Leto</th>
            <th>Mesec</th>
            <th>Status</th>
            <th>Št. dodatnih ležišč</th>
            <th>Št. prodanih namestitvenih enot</th>
            <th>Odprto dni</th>
            <th>Poslano</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in pagination.mesecnoPorocilo" @click="$router.push('/reports/' + report._id)">
            <td>{{report.idNO}}</td>
            <td>{{report.leto}}</td>
            <td>{{report.mesec | monthName}}</td>
            <td>{{report.statusPor}}</td>
            <td>{{report.stDodatnihlezisc}}</td>
            <td>{{report.stProdanihNE}}</td>
            <td>{{report.odprtDni}}</td>
            <td>{{report.created | date}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dataTables_wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
          Showing {{ pagination.first }}
          <span v-if="pagination.mesecnoPorocilo.length">
            to {{ pagination.first + pagination.mesecnoPorocilo.length - 1 }}
          </span>
          of {{ pagination.total }} entries</div>
        </div>
        <div class="col-sm-12 col-md-7">
          <pagination v-bind:pages="pagination.pages"></pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';

import moment from 'moment';

export default {
  name: 'ReportsList',
  components:{
    Pagination
  },
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    monthName: function(month){
      if(!month) return '';
      return moment(month, 'M').format('MMMM');
    }
  },
  data: () => ({
    pagination: {
      mesecnoPorocilo: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {},
  }),
  created(){
    const propSlug = this.$route.params.property;
    this.property = this.$store.state.host.properties.find(p => p.slug == propSlug);

    this.loadReports();
  },
  methods: {
    loadReports: function(){

      let url = '/reports?propertyId=' + this.property._id;

      const page = this.$route.query.page || 1;


      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if(!result.error){
          return this.pagination = result;
        }
      })
    }
  }
};
</script>
